export const FieldsDisplay = {
    REGO: "Registration No",
    StockID: "Stock ID",
    LotID: "LOT No",
    Vin: "VIN",
};